module.exports = __webpack_public_path__ + "img/check_mark.1663d398.svg";